<template>
  <component
    :is="wrapper"
    v-html="content"
  ></component>
</template>

<script setup>
import { ref, watchEffect } from "vue";
import { convertRichTextToHTML } from "../utils/renderRichText";

const props = defineProps({
  data: {
    type: String,
    default: () => "",
  },
});

const wrapper = ref("");
const content = ref("");

watchEffect(() => {
  if (props.data) {
    const richText = convertRichTextToHTML(props.data);
    wrapper.value = richText.wrapper;
    content.value = richText.content;
  }
});
</script>
